/* eslint-disable no-case-declarations */
import {
  BROKER_SETUP_CLEAR_FORM,
  BROKER_SETUP_SET_FORM_STRUCTURE,
  BROKER_SETUP_SCREEN_UPDATE_FORM,
  BROKER_SETUP_APP_URIS_REQUEST,
  BROKER_SETUP_APP_URIS_FAILURE,
  BROKER_SETUP_APP_URIS_SUCCESS,
  BROKER_SETUP_SAVE_CONFIG_REQUEST,
  BROKER_SETUP_SAVE_CONFIG_SUCCESS,
  BROKER_SETUP_SAVE_CONFIG_FAILURE,
} from '../../constants/ActionTypes';

const brokerSetupScreen = (
  state = {
    loading: false,
    formData: {},
    structure: [],
    errors: {},
    appUris: {
      isFetching: false,
      data: {},
    },
  },
  action
) => {
  switch (action.type) {
    case BROKER_SETUP_CLEAR_FORM:
      return {
        loading: false,
        formData: {},
        structure: [],
        errors: {},
        appUris: {
          isFetching: false,
          data: {},
        },
      };
    case BROKER_SETUP_SET_FORM_STRUCTURE:
      return {
        ...state,
        structure: action.value,
      };
    case BROKER_SETUP_SCREEN_UPDATE_FORM:
      const formDataUpdateForm = state.formData;

      if (!formDataUpdateForm[action.field]) {
        formDataUpdateForm[action.field] = '';
      }

      formDataUpdateForm[action.field] = action.value;

      return {
        ...state,
        formData: formDataUpdateForm,
      };
    case BROKER_SETUP_APP_URIS_REQUEST:
      const formDataAppUriRequest = state.appUris;

      formDataAppUriRequest.isFetching = true;

      return {
        ...state,
        appUris: formDataAppUriRequest,
        errors: {},
      };
    case BROKER_SETUP_APP_URIS_SUCCESS:
      const formDataAppUriSuccess = state.appUris;

      formDataAppUriSuccess.isFetching = false;
      formDataAppUriSuccess.data = action?.data?.data?.data;

      return {
        ...state,
        appUris: formDataAppUriSuccess,
      };
    case BROKER_SETUP_APP_URIS_FAILURE:
      return {
        ...state,
        errors: action.data,
      };
    case BROKER_SETUP_SAVE_CONFIG_REQUEST:
      return {
        ...state,
        errors: {},
        loading: true,
      };
    case BROKER_SETUP_SAVE_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case BROKER_SETUP_SAVE_CONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.data,
      };
    default:
      return state;
  }
};

export default brokerSetupScreen;
